export default "__VITE_ASSET__f82f5544__"